import { apiRequest } from './client';

export interface Region {
  code: string;
  name: string;
}

interface RegionsResponse {
  regions: Region[];
}

/** 居住地の選択肢 (地域マスタ)。マスタは backend に一元化している。 */
export async function fetchRegions(signal?: AbortSignal): Promise<Region[]> {
  const response = await apiRequest<RegionsResponse>('/regions', { signal });
  return response.regions;
}
